import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3s38anh4bi: FaireBrandEntity = {
  token: "b_3s38anh4bi",
  type: "brand",
  name: "Lady Jayne",
  avatarUrl:
    "https://cdn.faire.com/fastly/2fd058484f2334050e3adc24bbf76acb270e97f6562055bf302c581c42259d4c.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/185cd8cd095736074a8ac08c705cf15836a3ec43930c1bd058ba74a6a27b4a2f.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/2fd058484f2334050e3adc24bbf76acb270e97f6562055bf302c581c42259d4c.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/185cd8cd095736074a8ac08c705cf15836a3ec43930c1bd058ba74a6a27b4a2f.jpeg",
  location: "Culver City, CA, USA",
  minimumOrderDollars: 274,
  rating: 4.9,
  reviewCount: 59,
  isTopShop: true,
  isInsider: true,
  description:
    "Lady Jayne is your guide to on trend gifts for modern-day fashionistas of any age. With a penchant for color and style, discover all the fabulous giftables Lady Jayne has to offer, because life’s more fun when you indulge yourself – and others.\n",
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:45:00.062Z",
    importedBy: "entity-db-cli",
  },
};
